import { Navigate, Route, Routes } from "react-router-dom";
import MaintenanceMonitoring from "./maintenanceMonitoring";

const PartnershipRoutes = (props: any) => (
  <Routes>
    <Route path="/" element={<Navigate to="/partnership/maintenance-monitoring" />} />
    <Route
      path="/maintenance-monitoring"
      index
      element={<MaintenanceMonitoring {...props} />}
    />
  </Routes>
);

export default PartnershipRoutes;
